export default __webpack_public_path__ + "static/media/184.f28a3e7e.png";